import React from 'react'
import Icon from 'react-icon-base'

const Tinder = props => (
  <Icon viewBox="224.419 99.761 584.098 771.733" {...props}>
    <g>
      <path d="M536.9 99.9c6.8 5.2 12.7 11.6 19.2 17.2 58.7 55.4 112.5 116.6 155.8 184.9 41.9 66.1 74.101 139.2 88.4 216.4 7.899 42.3 10.5 85.699 5.899 128.5-2.099 17.9-5.199 35.8-10.899 52.9-8 24.8-18.5 48.9-32.9 70.7-12.4 18.8-27.9 35.6-45.8 49.2-19.7 14.9-42.2 25.8-65.6 33.3-29.101 9.3-59.601 13.9-90 16.4-36.301 2.699-72.801 3.199-109-1.4-41-5.1-81.7-16-118.2-35.7-33.8-18.2-63.5-44.899-82.6-78.5-22.1-38.4-29.4-83.9-25.9-127.8 3.6-46.5 18.4-91.6 38-133.7 17-36.2 37.8-70.5 60.899-103.1 19.7-27.6 40.9-54.1 64.101-78.9.399-.3 1.2-1 1.7-1.3-.4 20.9 1.6 41.9 7.6 62 6.1 20.5 16.4 39.8 30.1 56.3.801 1 1.4 2.4 2.9 2.601 29.7-22.3 57.8-47.3 79.7-77.4C533 321.4 548.199 285 554 246.9c7.699-49.3 1.1-100.6-17.1-147z" />
    </g>
  </Icon>
)

export default Tinder



// WEBPACK FOOTER //
// ./src/components/tinder-icon.js